import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NavController, AlertController, NavParams, LoadingController } from 'ionic-angular';
import { AuthService } from '../../providers/dbservice/authservice';
import { HomePage } from '../home/home';
import { DbserviceProvider } from '../../providers/dbservice/dbservice';
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: 'page-resetpwdLink',
  templateUrl: 'resetpwdLink.html'
})
export class ResetpwdLinkPage {

  public resetpwdLinkForm;
  emailChanged: boolean = false;
  submitAttempt: boolean = false;
  loading: any;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public authService: AuthService, public navParams: NavParams, public formBuilder: FormBuilder,
    public alertCtrl: AlertController, public loadingCtrl: LoadingController, private db: DbserviceProvider) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    console.log('ResetPwdLink constructor');
    this.styleName=this.configService.getConfig("STYLENAME");
    this.resetpwdLinkForm = formBuilder.group({
      mb_email_id: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])]
    });
  }

  resetPwdLink() {

    if (this.resetpwdLinkForm.dirty && this.resetpwdLinkForm.valid) {
      this.db.dbCol({ "action": "resetpwdLink", "mapObject": "member", "mb_email_id": this.resetpwdLinkForm.value.mb_email_id })
        .subscribe(
          ret => {
            if (ret['status'] === "0") {
              let alert = this.alertCtrl.create({
                subTitle: "Alamak how can you forget! Check your email and don't complain if it is in the spam folder!",
                buttons: ['OK']
              });
              alert.present();
              this.navCtrl.pop();
            }
          }
        )
    }
    ;
  }

  goback() {
    console.log('ResetpwdLinkPage goback');
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/resetpwd/resetpwdLink.ts